import { Star, Quote } from "lucide-react";
import { PageShell } from "../components/PageShell";
import { PageHero } from "../components/PageHero";
import { REVIEWS } from "../data/content";

export default function ClientReviews() {
  return (
    <PageShell>
      <PageHero
        eyebrow="Client Reviews"
        title="What clients say about"
        italic="working with us"
        subtitle="Selected feedback from investors across the UK, Europe, GCC, India and North America."
      />

      <section className="py-16 md:py-24 px-6 md:px-12">
        <div className="max-w-6xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-6" data-testid="reviews-grid">
          {REVIEWS.map((r, i) => (
            <div key={i} className="glass rounded-2xl p-8" data-testid={`review-${i}`}>
              <Quote size={24} className="text-[#c5a059]/70 mb-4" strokeWidth={1} />
              <p className="text-white/85 italic leading-relaxed mb-6 font-serif-display text-lg">
                "{r.quote}"
              </p>
              <div className="flex items-center justify-between">
                <div>
                  <div className="font-semibold">{r.name}</div>
                  <div className="text-xs text-white/50">{r.city}</div>
                </div>
                <div className="flex gap-0.5">
                  {[...Array(r.rating)].map((_, j) => (
                    <Star key={j} size={14} className="fill-[#c5a059] text-[#c5a059]" />
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>

        <p className="text-xs text-white/40 italic text-center max-w-2xl mx-auto mt-12">
          Names have been abbreviated to protect client privacy. Reviews reflect individual
          experience and do not constitute a guarantee of future outcomes.
        </p>
      </section>
    </PageShell>
  );
}
